import axios from "axios";
import {api} from "@/store/api";


// helper
function downloadBlob(data, filename) {
  const blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })

  // IE fallback
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename)
    return
  }

  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = filename
  link.style.display = 'none'

  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
function excelFilename(prefix) {
  const dateStr = new Date().toISOString().split('T')[0]
  return `${prefix}-${dateStr}.xlsx`
}
export default {
  state: {
    Treatments_Correlations: [],
    Treatments_Frequency: [],
    Igienizare_Overdue: [],
    Duration_Value: [],
    Recurrence_Loyalty: [],
    Recurrence_Loyalty_TotalPatients: null,
    Recurrence_Loyalty_Summary: null,
    Recurrence_Loyalty_Cohorts: [],
    Duration_Value_Statistics: [],
    Recurrence_Loyalty_Patients: [],
    Relation_Patient_Doctor: [],
    Relation_Loyalty_TotalPatients: null,
    Relation_Patient_Doctor_Summary: [],
    Relation_Doctors_Summary: null,
    Relation_DoctorPatients: [],
    Relation_DoctorPatients_Doctors: null,
    Total_Patients_Overdue: null,
    Total_Patients_With_Igienizare: null,
    Total_Patients_Duration_Value: null,
    Threshold_Months: null,
    Is_Request_Status: false,
    Loading: {},
    Filtered_Patients_Count: null,
  },

  getters: {
    isLoading: (state) => Object.values(state.Loading).some(Boolean)
  },

  mutations: {
    SET_TREATMENTS_FREQUENCY(state, data) {
      state.Treatments_Frequency = data || []
    },

    SET_TREATMENTS_CORRELATIONS(state, data) {
      state.Treatments_Correlations = data || []
    },

    SET_OVERDUE(state, payload) {
      const { data, totalPatientsOverdue, filteredPatientsCount, totalPatientsWithIgienizare, thresholdMonths } = payload
      state.Igienizare_Overdue = data || []
      state.Total_Patients_Overdue = totalPatientsOverdue
      state.Filtered_Patients_Count = filteredPatientsCount ?? totalPatientsOverdue
      state.Total_Patients_With_Igienizare = totalPatientsWithIgienizare
      state.Threshold_Months = thresholdMonths
    },

    SET_DURATION_VALUE (state, payload) {
      const { data, totalPatients, patientsAnalyzed, statistics } = payload
      state.Duration_Value = data || []
      state.Total_Patients_Duration_Value = totalPatients ?? null
      state.Duration_Value_Statistics = statistics ?? null
    },

    SET_RECURRENCE_LOYALTY (state, payload) {
      state.Recurrence_Loyalty_TotalPatients = payload.totalPatients ?? null
      state.Recurrence_Loyalty_Summary = payload.summary ?? null
      state.Recurrence_Loyalty_Cohorts = payload.cohortAnalysis ?? []
      state.Recurrence_Loyalty_Patients = payload.patients ?? []
    },

    SET_PATIENT_DOCTOR_RELATION (state, payload) {
      state.Relation_Loyalty_TotalPatients = payload.totalPatients ?? null
      state.Relation_Patient_Doctor_Summary = payload.summary ?? null
      state.Relation_DoctorPatients = payload.patients ?? []
      state.Relation_Doctors_Summary = payload.doctorsSummary ?? null
    },

    SET_REQUEST_STATUS(state, { key, value }) {
      state.Loading = { ...state.Loading, [key]: value }
    }
  },

  actions: {
    async fetchTreatments ({ commit }, filters = {}) {
      try {
        commit('SET_REQUEST_STATUS', { key: 'treatments', value: true })
        commit('SET_TREATMENTS_FREQUENCY', [])

        const allowedFilters = ['doctor', 'dateFrom', 'dateTo', 'lastMonths']

        const params = Object.fromEntries(
          Object.entries(filters)
            .filter(([key, value]) =>
              allowedFilters.includes(key) &&
              value !== null &&
              value !== ''
            )
        )

        const { data } = await axios.get(api.treatment_frequency, { params })

        commit('SET_TREATMENTS_FREQUENCY', data.data)

      } catch (err) {
        console.error('Error fetching treatments:', err.message)
      } finally {
        commit('SET_REQUEST_STATUS', { key: 'treatments', value: false })
      }
    },

    async fetchCorrelations ({ commit }, filters = {}) {
      try {
        commit('SET_REQUEST_STATUS', { key: 'correlations', value: true })
        commit('SET_TREATMENTS_CORRELATIONS', [])

        const params = new URLSearchParams()

        const { treatment, doctor, gender, ageGroup, lastMonths, dateFrom, dateTo } = filters

        if (treatment?.trim()) params.append('treatment', treatment.trim())
        if (doctor)            params.append('doctor', doctor)
        if (gender)            params.append('gender', gender)
        if (ageGroup)          params.append('ageGroup', ageGroup)

        if (lastMonths != null) {
          params.append('lastMonths', lastMonths)
        } else {
          if (dateFrom) params.append('dateFrom', dateFrom)
          if (dateTo)   params.append('dateTo', dateTo)
        }

        const queryString = params.toString()
        const url = queryString
          ? `${api.treatment_correlations}?${queryString}`
          : api.treatment_correlations

        const { data } = await axios.get(url)

        commit('SET_TREATMENTS_CORRELATIONS', data.data)

      } catch (err) {
        console.error('Error fetching correlations:', err.message)
        commit('SET_TREATMENTS_CORRELATIONS', [])
      } finally {
        commit('SET_REQUEST_STATUS', { key: 'correlations', value: false })
      }
    },

    async fetchOverdue ({ commit }, filters = {}) {
      try {
        commit('SET_REQUEST_STATUS', { key: 'overdue', value: true })
        commit('SET_OVERDUE', { data: [], totalPatientsOverdue: null, filteredPatientsCount: null, totalPatientsWithIgienizare: null, thresholdMonths: null })

        const params = new URLSearchParams()
        if (filters.dateFrom)           params.append('dateFrom', filters.dateFrom)
        if (filters.dateTo)             params.append('dateTo', filters.dateTo)
        if (filters.minMonths != null)  params.append('minMonths', filters.minMonths)
        if (filters.maxMonths != null)  params.append('maxMonths', filters.maxMonths)

        const query = params.toString()
        const url = query ? `${api.igienizare_overdue}?${query}` : api.igienizare_overdue

        const { data } = await axios.get(url)
        commit('SET_OVERDUE', data)
      } catch (err) {
        console.error('Error fetching overdue:', err.message)
      } finally {
        commit('SET_REQUEST_STATUS', { key: 'overdue', value: false })
      }
    },

    async fetchDurationValue ({ commit }, filters = {}) {
      try {
        commit('SET_REQUEST_STATUS', { key: 'durationValue', value: true })
        commit('SET_DURATION_VALUE', { data: [], totalPatients: null })

        const { lastMonths, dateFrom, dateTo } = filters

        const params = {}

        if (lastMonths != null) {
          params.lastMonths = lastMonths
        } else {
          if (dateFrom) params.dateFrom = dateFrom
          if (dateTo)   params.dateTo = dateTo
        }

        const { data } = await axios.get(api.treatment_duration_value, { params })

        commit('SET_DURATION_VALUE', data)

      } catch (err) {
        console.error('Error fetching duration value:', err.message)
      } finally {
        commit('SET_REQUEST_STATUS', { key: 'durationValue', value: false })
      }
    },

    async fetchRecurrenceLoyalty ({ commit }) {
      try {
        commit('SET_REQUEST_STATUS', { key: 'recurrenceLoyalty', value: true })
        const { data } = await axios.get(`${api.recurrence_loyalty}`)
        commit('SET_RECURRENCE_LOYALTY', data)
      } catch (err) {
        console.error('Error fetching treatments:', err.message)
      } finally {
        commit('SET_REQUEST_STATUS', { key: 'recurrenceLoyalty', value: false })
      }
    },

    async fetchRelationPatientDoctor ({ commit }) {
      try {
        commit('SET_REQUEST_STATUS', { key: 'relationPatientDoctor', value: true })
        const { data } = await axios.get(`${api.doctor_continuity}`)
        commit('SET_PATIENT_DOCTOR_RELATION', data)
      } catch (err) {
        console.error('Error fetching treatments:', err.message)
      } finally {
        commit('SET_REQUEST_STATUS', { key: 'relationPatientDoctor', value: false })
      }
    },

    async downloadTreatmentsExcel({state}, filters = {}) {
      try {
        const params = new URLSearchParams({ format: 'excel' })
        if (filters.dateFrom)           params.append('dateFrom', filters.dateFrom)
        if (filters.dateTo)             params.append('dateTo', filters.dateTo)
        if (filters.lastMonths != null) params.append('lastMonths', filters.lastMonths)

        const response = await axios.get(`${api.treatment_frequency}?${params}`, {
          responseType: 'blob'
        })

        downloadBlob(response.data, excelFilename('frecventa-tratamente'))

      } catch (err) {
        console.error('Error downloading treatments excel:', err.message)
        throw err
      }
    },

    async downloadDurationValueExcel({}, filters = {}) {
      try {
        const params = new URLSearchParams({ format: 'excel' })
        if (filters.lastMonths != null) {
          params.append('lastMonths', filters.lastMonths)
        } else {
          if (filters.dateFrom) params.append('dateFrom', filters.dateFrom)
          if (filters.dateTo)   params.append('dateTo', filters.dateTo)
        }

        const response = await axios.get(`${api.treatment_duration_value}?${params}`, {
          responseType: 'blob'
        })
        downloadBlob(response.data, excelFilename('tratament-durata-valoare'))
      } catch (err) {
        console.error('Error downloading duration value excel:', err.message)
        throw err
      }
    },

    async downloadCorrelationsExcel({ state }, filters = {}) {
      try {

        const params = new URLSearchParams({ format: 'excel' })
        if (filters.treatment?.trim()) params.append('treatment', filters.treatment.trim())
        if (filters.gender)            params.append('gender', filters.gender)
        if (filters.ageGroup)          params.append('ageGroup', filters.ageGroup)
        if (filters.lastMonths != null) {
          params.append('lastMonths', filters.lastMonths)
        } else {
          if (filters.dateFrom) params.append('dateFrom', filters.dateFrom)
          if (filters.dateTo)   params.append('dateTo', filters.dateTo)
        }

        const response = await axios.get(`${api.treatment_correlations}?${params}`, {
          responseType: 'blob'
        })

        downloadBlob(response.data, excelFilename('corelatii-tratamente'))
      } catch (err) {
        console.error('Error downloading correlations excel:', err.message)
        throw err
      }
    },

    async downloadOverdueExcel({state}, filters = {}) {
      try {
        const params = new URLSearchParams({ format: 'excel' })
        if (filters.dateFrom)          params.append('dateFrom', filters.dateFrom)
        if (filters.dateTo)            params.append('dateTo', filters.dateTo)
        if (filters.minMonths != null) params.append('minMonths', filters.minMonths)
        if (filters.maxMonths != null) params.append('maxMonths', filters.maxMonths)

        const response = await axios.get(`${api.igienizare_overdue}?${params}`, {
          responseType: 'blob'
        })
        downloadBlob(response.data, excelFilename('igienizare-depasita'))
      } catch (err) {
        console.error('Error downloading overdue excel:', err.message)
        throw err
      }
    },

    async downloadRecurrenceLoyaltyExcel() {
      try {
        const response = await axios.get(`${api.recurrence_loyalty}?format=excel`, {
          responseType: 'blob'
        })
        downloadBlob(response.data, excelFilename('recurenta-loialitate'))
      } catch (err) {
        console.error('Error downloading recurrence loyalty excel:', err.message)
        throw err
      }
    },

    async downloadRelationPatientDoctorExcel() {
      try {
        const response = await axios.get(`${api.doctor_continuity}?format=excel`, {
          responseType: 'blob'
        })
        downloadBlob(response.data, excelFilename('recurenta-loialitate'))
      } catch (err) {
        console.error('Error downloading recurrence loyalty excel:', err.message)
        throw err
      }
    },
  }
}
